import { render, staticRenderFns } from "./BuyInvestment.vue?vue&type=template&id=6d70e868"
import script from "./BuyInvestment.vue?vue&type=script&lang=js"
export * from "./BuyInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports